module.exports = __webpack_public_path__ + "static/img/00.63bcef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/00.png
// module id = KjW8
// module chunks = 30